import React from 'react';
import { theme } from '../../theme';

const statusColors = {
  pending: { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  approved: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  rejected: { bg: '#FEE2E2', color: '#991B1B', border: '#FCA5A5' },
  active: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  inactive: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  open: { bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
  closed: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  'in-progress': { bg: '#EDE9FE', color: '#5B21B6', border: '#C4B5FD' },
  in_progress: { bg: '#EDE9FE', color: '#5B21B6', border: '#C4B5FD' },
  resolved: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  cancelled: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  canceled: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  low: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  medium: { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  high: { bg: '#FEE2E2', color: '#991B1B', border: '#FCA5A5' },
  critical: { bg: '#FDF2F8', color: '#9D174D', border: '#F9A8D4' },
  urgent: { bg: '#FEE2E2', color: '#991B1B', border: '#FCA5A5' },
  available: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  assigned: { bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
  maintenance: { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  retired: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  manager_approved: { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  submitted: { bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
  manager_reviewed: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  draft: { bg: '#F3F4F6', color: '#6B7280', border: '#D1D5DB' },
  modified: { bg: '#EDE9FE', color: '#5B21B6', border: '#C4B5FD' },
  paid: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  scheduled: { bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
  completed: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  'on-hold': { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  on_hold: { bg: '#FEF3C7', color: '#92400E', border: '#FCD34D' },
  shortlisted: { bg: '#DBEAFE', color: '#1E40AF', border: '#93C5FD' },
  hired: { bg: '#D1FAE5', color: '#065F46', border: '#6EE7B7' },
  default: { bg: theme.lightBg, color: theme.primaryDark, border: theme.primaryLight },
};

function Badge({ status, label, size = 'sm', byName }) {
  const key = (status || '').toLowerCase().replace(/\s+/g, '-');
  const colors = statusColors[key] || statusColors.default;
  const displayLabel = label || (status ? status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '');

  const padding = size === 'sm' ? '0.2rem 0.6rem' : '0.35rem 0.9rem';
  const fontSize = size === 'sm' ? '0.72rem' : '0.8rem';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.25rem',
        padding,
        fontSize,
        fontWeight: 600,
        borderRadius: '9999px',
        background: colors.bg,
        color: colors.color,
        border: `1px solid ${colors.border}`,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
      }}
    >
      {displayLabel}
      {byName && (
        <span style={{ fontWeight: 400, opacity: 0.8 }}>· {byName}</span>
      )}
    </span>
  );
}

export default Badge;
